import React from "react";

import "./proposalStyle.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { proposalDate } from "../../../utils/date";
import { proposalStatus, userRoleList } from "../../../utils/constants";
import { useProposal } from "../../../hooks/useProposal";
import { Button, Modal } from "react-bootstrap";
import {
  getProposalPresentation,
  isProposalPayable,
} from "../../../utils/proposalPresentation";

// Custom styles for the modal
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", // Enables flexbox
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
  },
  content: {
    position: "relative",
    width: "90%",
    maxWidth: "554px", // Controls modal width
    maxHeight: "90vh", // Ensures it doesn't exceed the viewport height
    margin: "auto", // Centers in case of fallback
    borderRadius: "12px",
    padding: "48px",
    overflow: "auto", // Enables scroll for overflowing content
  },
};

const ProposalTimeLineModal = ({
  isOpen,
  onClose,
  proposals,
  onRefuseProposal,
  setModalRecapOpen,
  role,
  direct,
  setModalAdressOpen,
  setSelectedProposal,
}) => {
  // const [scrollEl, setScrollEl] = useState();

  // useEffect(() => {
  //   if (scrollEl) {
  //     scrollEl.scrollTop = 1000;
  //   }
  // }, [scrollEl, isOpen, proposals]);

  return (
    <Modal
      className="modal fade"
      size="lg"
      show={isOpen}
      onHide={() => {
        onClose(false);
      }}
      centered
      // ariaHideApp={false}
      // htmlOpenClassName={"z-[999]"}
      // className={"h-fit bg-white z-[999] "}
      // isOpen={isOpen}
      // onRequestClose={onClose}
      // style={modalStyles}
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              onClose(false);
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className="flex flex-col justify-start w-full h-fit lg:px-4">
            <h2 className="text-[26px] leading-6 text-[#FF6600] w-full text-center font-bold  mb-4">
              Historique de propositions
            </h2>
            <PerfectScrollbar
              // containerRef={(ref) => {
              //   setScrollEl(ref);
              // }}
              className="widget-timeline dz-scroll max-h-[380px] h-fit py-2"
            >
              <ul className="timeline">
                {!!proposals?.length &&
                  proposals
                    .slice()
                    .reverse()
                    .map((proposal, index) => (
                      <ProposalBadge
                        key={proposal.id || index}
                        proposal={proposal}
                        setModalRecapOpen={setModalRecapOpen}
                        onRefuseProposal={onRefuseProposal}
                        role={role}
                        direct={direct}
                        setModalAdressOpen={setModalAdressOpen}
                        setSelectedProposal={setSelectedProposal}
                        onClose={onClose}
                      />
                    ))}
              </ul>
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProposalTimeLineModal;

const ProposalBadge = ({
  proposal,
  onRefuseProposal,
  setModalRecapOpen,
  role,
  direct,
  setModalAdressOpen,
  setSelectedProposal,
  onClose,
}) => {
  const presentation = getProposalPresentation(proposal?.status);
  const { onDeleteProposal } = useProposal();

  return (
    <li>
      <div
        className="timeline-badge"
        style={{backgroundColor: presentation.color}}
      ></div>
      <div
        className="timeline-panel text-muted flex flex-col justify-start gap-1"
        style={{backgroundColor: presentation.backgroundColor}}
      >
        <div className="flex items-start justify-between gap-3">
          <span>{proposalDate(proposal?.appointmentDate)}</span>
          <strong
            className="text-right text-xs sm:text-sm"
            style={{color: presentation.color}}
          >
            {presentation.label}
          </strong>
        </div>
        <h6 className="mb-0 break-all">{proposal?.title}</h6>
        <p className="mb-0 break-all">{proposal?.comment ?? ""}</p>
        <strong style={{color: presentation.color}}>
          {proposal?.initialBudget} €
        </strong>
        {role === userRoleList.CLIENT &&
          proposal?.status === proposalStatus.INITIATED && (
            <div className="flex flex-col justify-center sm:flex-row sm:justify-end items-center gap-2 !mb-0">
              <button
                className="p-2 min-w-[100px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid "
                onClick={() => onRefuseProposal(proposal?.id)}
              >
                Refuser
              </button>
              <button
                data-testid={`proposal-accept-${proposal?.id}`}
                className="p-2 min-w-[100px]   !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
                onClick={() => {
                  setSelectedProposal(proposal);
                  onClose();
                  if (direct) {
                    setModalAdressOpen(true);
                  } else {
                    setModalRecapOpen(true);
                  }
                }}
              >
                Accepter
              </button>
            </div>
          )}
        {role === userRoleList.CLIENT && isProposalPayable(proposal) && (
            <div className="flex justify-end items-center gap-2 !mb-0">
              <button
                className="p-2 min-w-[100px] !rounded-lg bg-[#FFF0F2] !text-[#D80027] !border-[#D80027] !border border-solid"
                onClick={() => {
                  onRefuseProposal(proposal?.id);
                  onClose();
                }}
              >
                Refuser
              </button>
              <button
                data-testid={`proposal-pay-${proposal?.id}`}
                className="p-2 min-w-[100px]   !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
                onClick={() => {
                  setSelectedProposal(proposal);
                  onClose();
                  setModalRecapOpen(true);
                }}
              >
                Payer
              </button>
            </div>
          )}
        {role === userRoleList.TECHNICIAN &&
          [proposalStatus.INITIATED].includes(proposal?.status) && (
            <div className="flex justify-end items-center gap-2 !mb-0">
              <button
                className="p-2 min-w-[100px]   !rounded-lg bg-[#FFCACA] text-[#FF0000] "
                onClick={() => {
                  onDeleteProposal(proposal?.id);
                }}
              >
                Annuler
              </button>
            </div>
          )}
      </div>
    </li>
  );
};
